import PropTypes from 'prop-types';
import React from 'react';
import DropdownIcon from '@tradera/blueprint/theme/icons2/dropdown.svg?jsx';

const SearchCategory = ({
    handleCategoryChange,
    selectOptions,
    selectedCategoryId,
    chosenCategory
}) => {
    if (!selectOptions) {
        return;
    }

    const handleChange = handleCategoryChange;
    const isDefaultSelected = selectedCategoryId === 0;

    return (
        <div
            className={`slim-header__search-category d-flex align-items-center border-0  ${
                !isDefaultSelected
                    ? 'bg-dark text-white'
                    : 'bg-branded text-dark'
            }`}>
            <span className="pl-4 pr-2">
                <span className="align-text-bottom">{chosenCategory.name}</span>
                <span className="pl-1 col-auto d-inline">
                    <DropdownIcon className="icon icon-sm align-middle" />
                </span>
            </span>
            <select
                name="categoryId"
                tabIndex="2"
                className="slim-header__search-category-select"
                onChange={handleChange}
                value={selectedCategoryId}>
                {selectOptions.map((option, index) => {
                    return option ? (
                        <option key={index} value={option.id}>
                            {option.name}
                        </option>
                    ) : null;
                })}
            </select>
        </div>
    );
};

SearchCategory.propTypes = {
    handleCategoryChange: PropTypes.func,
    selectOptions: PropTypes.array,
    selectedCategoryId: PropTypes.number,
    chosenCategory: PropTypes.object
};

export default SearchCategory;
